import { AxiosError } from "axios";

export const axiosErrorMatches = (e: unknown, message: string) =>
  e instanceof AxiosError && e.response?.data?.ErrorMessage === message;
